export default [
    {
        title: 'Restaurant, Comida Rápida',
        image: '/static/images/mobile.jpg',
        path: '/products/gadgets/111',
    },
    {
        title: 'Distribuidoras',
        image: '/static/images/sports.jpg',
        path: '/products/men/103',
    },
    {
        title: 'Centros Educativos',
        image: '/static/images/headphone.jpg',
        path: '/products/gadgets/101',
    },
    {
        title: 'Boticas, Farmacias',
        image: '/static/images/t-shirts.jpg',
        path: '/products/men/105',
    },
    {
        title: 'Zapaterías',
        image: '/static/images/watch.jpg',
        path: '/products/gadgets/112',
    },
    {
        title: 'Hoteles',
        image: '/static/images/shoes.jpg',
        path: '/products/men/101',
    },
];
